import MultiStepForm from './pages/MultiStepForm.jsx';

function App() {
  return <MultiStepForm />;
}

export default App;
